import StartingEquipmentPane from "./StartingEquipmentPane";

export default StartingEquipmentPane;
export { StartingEquipmentPane };
